if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

init() {

    const shippingGoal = Math.round(
        Number(this.getAttribute('data-free-shipping')) *
        (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
    );

    const giftGoal = Math.round(
        Number(this.getAttribute('data-free-gift')) *
        (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1)
    );

    const giftName = this.getAttribute('data-free-gift-name') || 'Free Sunglasses';

    // Total INCLUDING the free gift
    // Used for Free Shipping
    const cartTotal = Number(
        this.getAttribute('data-cart-total')
    );

    // Total EXCLUDING free-gift products
    // Used for Free Gift eligibility
    const qualifyingTotal = Number(
        this.getAttribute('data-cart-total-without-gift')
    );

    let width = 0;

    const textElement = this.querySelector(
        '[data-js-free-shipping-text]'
    );

    const slider = this.querySelector(
        '[data-js-free-shipping-slider]'
    );


    // ==========================================================
    // FREE SHIPPING NOT REACHED
    // ==========================================================

    if (cartTotal < shippingGoal) {

        const remaining = shippingGoal - cartTotal;

        textElement.innerHTML = `
            <span class="kt-cart-shipping-error">
                Spend
                <strong>
                    ${this._formatMoney(
                        remaining,
                        KROWN.settings.shop_money_format
                    )}
                </strong>
                more to qualify for
                <strong>FREE Shipping</strong>.
            </span>
        `;

        width = shippingGoal > 0
            ? (cartTotal / shippingGoal) * 100
            : 0;
    }


    // ==========================================================
    // FREE SHIPPING REACHED
    // BUT FREE GIFT NOT REACHED
    // ==========================================================

    else if (
        giftGoal > 0 &&
        qualifyingTotal < giftGoal
    ) {

        const remaining = giftGoal - qualifyingTotal;

        textElement.innerHTML = `
            <span class="kt-cart-shipping-success">
                You're eligible for
                <strong>FREE Shipping!</strong>
            </span>

            <span class="kt-cart-gift-warning">
                Spend
                <strong>
                    ${this._formatMoney(
                        remaining,
                        KROWN.settings.shop_money_format
                    )}
                </strong>
                more on other products to claim your
                <strong>${giftName}</strong>.
            </span>
        `;

        /*
         * Once free shipping is reached, the progress bar
         * switches to the gift goal.
         */
        width = giftGoal > 0
            ? (qualifyingTotal / giftGoal) * 100
            : 100;
    }


    // ==========================================================
    // FREE SHIPPING + FREE GIFT REACHED
    // ==========================================================

    else {

        textElement.innerHTML = `
            <span class="kt-cart-shipping-success">
                You're eligible for
                <strong>FREE Shipping!</strong>
            </span>

            <span class="kt-cart-gift-success">
                🎁 You've unlocked your
                <strong>${giftName}</strong>!
            </span>
        `;

        width = 100;
    }


    // ==========================================================
    // PREVENT OVERFLOW
    // ==========================================================

    width = Math.max(
        0,
        Math.min(width, 100)
    );


    if (slider) {
        slider.style.width = width + "%";
    }
}
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}